import React from "react";

import { FaPhoneAlt, FaEnvelope, FaUser } from "react-icons/fa";
import { HiDotsVertical } from "react-icons/hi";
import { IoMdSchool } from "react-icons/io";

const EmployeeCard = ({ person, onOptions }) => {
  return (
    <>
      <div className="flex flex-row justify-center items-center bg-white border border-slate-300 py-3 px-4 mt-2 rounded-xl">
        <div className="w-[25%] flex flex-row justify-start items-center">
          <img
            className="h-12 w-12 rounded-full object-cover"
            src={person?.profileImage}
          />

          {/* Personal Details */}
          <div className="flex flex-col ml-3 ">
            <p className="text-black text-base font-medium">
              {person?.firstname ?? ""} {person?.lastname ?? ""}
            </p>

            <p className="text-gray-700 text-sm font-normal">
              {person?.email ?? ""}
            </p>
          </div>
        </div>

        <div style={{ flex: 1 }} />

        {/* Phone Number */}
        <div className="flex flex-row justify-start items-center w-[10%]">
          <FaPhoneAlt className="text-mpPurple" />
          <p className="ml-2 text-black text-sm font-medium">
            {person?.mobile ?? ""}
          </p>
        </div>

        <div style={{ flex: 1 }} />

        {/* Email Address */}
        <div className="flex flex-row justify-start items-center w-[20%]">
          <FaEnvelope className="text-mpPurple" />
          <p className="ml-2 text-black text-sm font-medium">
            {person?.email ?? ""}
          </p>
        </div>

        {person?.schoolMode ? <IoMdSchool className="ml-8 text-xl" /> : null}

        <div style={{ flex: 1 }} />

        {/* Usertype */}
        <div className="flex flex-row justify-start items-center w-[10%]">
          <FaUser
            className={person?.status ? "text-mpPurple" : "text-red-600"}
          />
          <p className="ml-2 text-black text-sm font-medium">
            {person?.usertype == 1
              ? "Manager"
              : person?.usertype == 2
              ? "Person"
              : "Admin"}
          </p>
        </div>

        {/* User Actions */}
        <div
          onClick={() => onOptions(person)}
          className="bg-mpPurple bg-opacity-20 p-2 rounded-lg ml-2 cursor-pointer"
        >
          <HiDotsVertical className="text-mpPurple text-xl" />
        </div>
      </div>
    </>
  );
};

export default EmployeeCard;
